import React, {Component} from 'react';
import MaterialIcon from '../../MaterialIcon';
import {showToastForFrontend} from "../../../actions/toastActions";
import messageCodes from "../../../utils/messageCodes";
import {connect} from "react-redux";
import {addContextProperty, removeContextProperty} from "../../../actions/contextPropertiesActions";


/*
*   Props:
*     contextProps: Array
*        name: String
*        publicName: String
*        description: String
*        addedByUpdater: Boolean
 */
class ContextPropertyTab extends Component {

    constructor(props) {
        super(props);

        this.state = {
            name: "",
            publicName: "",
            description: ""
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.deleteContextProps = this.deleteContextProps.bind(this);
        this.addContextProp = this.addContextProp.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handleKeyUp = this.handleKeyUp.bind(this);
    }

    handleInputChange(e, fieldName) {
        let update = e.target.value || "";
        let updateParam = {};
        if (fieldName === "name") {
            update = update.replace(/\s/g, '')
        }
        updateParam[fieldName] = update;

        this.setState({
            ...updateParam
        });
    }

    addContextProp() {

        if (this.validateFields()) {
            const newContextProp = {
                name: this.state.name,
                publicName: this.state.publicName,
                description: this.state.description,
                addedByUpdater: false
            };

            this.props.addContextProperty(newContextProp);

            this.setState({
                name: "",
                publicName: "",
                description: ""
            })
        } else {
            this.props.showToastForFrontend(messageCodes.SAMPLE_WARNING)
        }


    }

    deleteContextProps(deleteIndex) {
        const toBeDeletedContextProp = this.props.contextProps[deleteIndex];
        this.props.removeContextProperty(toBeDeletedContextProp);
    }

    validateFields() {
        if (this.state.name.length < 1)
            return false;
        if (this.props.contextProps.some((prop) => prop.name === this.state.name))
            return false;

        return true;
    }

    handleKeyDown(event) {
        event.stopPropagation();
    }

    handleKeyUp(event) {
        event.stopPropagation();
    }


    render() {
        return (
            <div className="context-property-tab">
                <div className="context-property-form">
                    <input className="panel-input" type="text" name="name" placeholder="Name"
                           value={this.state.name}
                           onKeyDown={this.handleKeyDown}
                           onKeyUp={this.handleKeyUp}
                           onChange={(e) => this.handleInputChange(e, "name")}/>
                    <input className="panel-input" type="text" name="public-name" placeholder="Public Name"
                           value={this.state.publicName} onChange={(e) => this.handleInputChange(e, "publicName")}/>
                    <input className="panel-input" type="text" name="description" placeholder="Description"
                           value={this.state.description}
                           onChange={(e) => this.handleInputChange(e, "description")}/>
                    <div className="add-property" onClick={this.addContextProp}><MaterialIcon icon="add_circle"/>Add
                        Property
                    </div>
                </div>

                <div className="context-property-table">
                    <table className={"table"}>
                        <thead>
                        <tr>
                            <th>
                                Name
                            </th>
                            <th>
                                Public Name
                            </th>
                            <th>
                                Description
                            </th>
                            <th>
                                Usage Count
                            </th>
                            <th>

                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.props.contextProps && this.props.contextProps.map((contextProp, index) => (
                            contextProp.addedByUpdater ? (
                                <tr className="updated" key={contextProp.name}>
                                    <td>{contextProp.name}</td>
                                    <td>{contextProp.publicName}</td>
                                    <td>{contextProp.description}</td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            ) : (
                                <tr key={contextProp.name}>
                                    <td>{contextProp.name}</td>
                                    <td>{contextProp.publicName}</td>
                                    <td>{contextProp.description}</td>
                                    <td></td>
                                    <td>
                                        <MaterialIcon icon="close" onClick={() => this.deleteContextProps(index)}/>
                                    </td>
                                </tr>
                            )
                        ))}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        contextProps: state.contextProperties
    }
}

export default connect(mapStateToProps, {
    showToastForFrontend,
    addContextProperty,
    removeContextProperty
})(ContextPropertyTab);